module.exports = __webpack_public_path__ + "static/img/img1.5bb38190.png";